<template>
  <v-flex sm12>
    <v-container fluid pt-5 pb-5 mt-5>
      <v-flex>
        <v-card md12 class="mb-5 elevation-0">
          <v-tabs centered color="#D5D5D5" show-arrows dark v-model="tab" class="rounded-tabs">
            <v-toolbar-title lass="title">
              <div class="display-1 mt-3 mr-5 tamany_titol tw-txt-color-primary">STATUS CLIENTE {{ userid }}</div>
            </v-toolbar-title>
            <v-tabs-slider color="primary"></v-tabs-slider>

            <v-tab href="#tab-1" class="tw-txt-color-primary"> <v-icon class="tw-txt-color-primary mr-1">home</v-icon> {{ 'client_dashboard.title' | t }} </v-tab>

            <v-tab href="#tab-2" class="tw-txt-color-primary"> <v-icon class="tw-txt-color-primary mr-1">show_chart</v-icon> {{ 'statistics.title' | t }} </v-tab>

            <v-tab href="#tab-3" class="tw-txt-color-primary"> <v-icon class="tw-txt-color-primary mr-1">developer_board</v-icon>{{ 'workers.title' | t }} </v-tab>

            <v-tab href="#tab-4" class="tw-txt-color-primary"> <v-icon class="tw-txt-color-primary mr-1">developer_board</v-icon> {{ 'workers.title' | t }} Stats </v-tab>

            <v-tab href="#tab-5" class="tw-txt-color-primary"> <v-icon class="tw-txt-color-primary mr-1">assignment</v-icon> {{ 'billing.title' | t }} </v-tab>

            <v-tab href="#tab-6" class="tw-txt-color-primary"> <v-icon class="tw-txt-color-primary mr-1">person</v-icon> {{ 'settings.title' | t }} </v-tab>

            <v-tab-item value="tab-1">
              <div class="headline tw-txt-color-primary ml-3 mt-3 subtitol rounded-tabs-sub">{{ 'usereditor.token' | t }}</div>
              <v-flex class="ml-3">
                <consumer :user="userid" />
              </v-flex>
            </v-tab-item>

            <v-tab-item value="tab-2">
              <div class="headline tw-txt-color-primary ml-3 mt-3 subtitol rounded-tabs-sub">{{ 'usereditor.graphic' | t }}</div>
              <v-flex class="ml-3">
                <grafica :user="userid" />
              </v-flex>

              <div class="headline tw-txt-color-primary ml-3 mt-3 subtitol rounded-tabs-sub">{{ 'usereditor.latest' | t }}</div>
              <v-flex class="ml-3">
                <consumer-control :user="userid" />
              </v-flex>
            </v-tab-item>

            <v-tab-item value="tab-3">
              <div class="headline tw-txt-color-primary ml-3 mt-3 subtitol rounded-tabs-sub">{{ 'workers.title' | t }}</div>
              <v-flex class="ml-3">
                <w-low v-for="wtype in worker_types" :w_type="wtype" :key="wtype" :user="userid" />
              </v-flex>
            </v-tab-item>

            <v-tab-item value="tab-4">
              <div class="headline tw-txt-color-primary ml-3 mt-3 subtitol rounded-tabs-sub">{{ 'usereditor.workers_stats' | t }}</div>
              <v-flex class="ml-3">
                <workers-stats v-for="wtype in worker_types" :w_type="wtype" :key="wtype" :user="userid" />
              </v-flex>
            </v-tab-item>

            <v-tab-item value="tab-5">
              <div class="headline tw-txt-color-primary ml-3 mt-3 subtitol rounded-tabs-sub">{{ 'usereditor.orders' | t }}</div>
              <v-flex class="ml-3">
                <billing-list :user="userid" />
              </v-flex>
            </v-tab-item>

            <v-tab-item value="tab-6">
              <v-flex md12 class="mt-3">
                <div class="headline tw-txt-color-primary ml-3 mt-3 subtitol rounded-tabs-sub">{{ 'usereditor.title' | t }}</div>
                <v-flex class="ml-3">
                  <user-form :user="userid" />
                </v-flex>
              </v-flex>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-container>
  </v-flex>
</template>

<script>
import Consumer from '@/components/Consumer'
import Grafica from '@/components/Grafica'
import ConsumerControl from '@/components/ConsumerControl'
import BillingList from '@/components/BillingList'
import UserForm from '@/components/UserForm'
import WLow from '@/components/Workers/WLow'
import WorkersStats from '@/components/Workers/WorkersStats'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    Consumer,
    Grafica,
    ConsumerControl,
    BillingList,
    UserForm,
    WLow,
    WorkersStats
  },
  computed: {
    ...mapGetters(['getServer', 'getTokenHeader'])
  },
  data() {
    return { userid: 0, worker_types: [] }
  },
  methods: {
    ...mapActions(['setMyConsumers'])
  },
  created() {
    if (this.$route.params.id) {
      this.userid = this.$route.params.id
      this.$http
        .get(`${this.getServer}/users/${this.userid}/consumers`, this.getTokenHeader)
        .then(data => {
          if (data.data) {
            this.setMyConsumers(data.data)
            this.worker_types = data.data.filter(consumer => ['instagram', 'facebook', 'twitter'].includes(consumer.api)).map(consumer => consumer.api)
          }
        })
        .catch(() => {
          // error
        })
    }
  }
}
</script>

<style scoped>
.rounded-tabs {
  border-radius: 6px !important;
}
.rounded-tabs-sub {
  border-radius: 6px !important;
}
.tamany_titol {
  font-size: 28px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
.tamany_titol_sitebar {
  font-size: 18px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
.ratlla {
  height: 3px !important;
}
.subtitol {
  padding-top: 8px !important;
  padding-left: 20px !important;
  background-color: #f2f2f2 !important;
  padding-bottom: 6px !important;
}
.nobot {
  padding-bottom: 0px !important;
}
.background {
  /*background-color: rgb(241 85 80 / 15%) !important;*/
  background: linear-gradient(to bottom, rgb(241 85 80 / 15%), #ffffff) !important; /* De rojo a blanco */
}
.tw-txt-color-primary {
  /*color: #00ff37 !important;*/
  color: #515151 !important;
}
</style>
